import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@/components/ui/drawer';
import { useIsMobile } from '@/hooks/use-mobile';
import SendMoneyMethodOptions from './send-money-method-options';

type SendMoneySelectorProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onExternalTransfer: () => void;
};

export default function SendMoneySelector({ open, onOpenChange, onExternalTransfer }: SendMoneySelectorProps) {
  const isMobile = useIsMobile();
  const selectExternalTransfer = () => {
    onOpenChange(false);
    onExternalTransfer();
  };

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
        <DrawerContent className="max-h-[90dvh] overflow-hidden border border-primary bg-secondary !px-0 !pb-0 !pt-[1rem] dark:!bg-secondary" side="bottom">
          <div className="flex min-h-0 flex-col overflow-hidden px-[1.6rem] pb-[2rem]">
            <header className="relative shrink-0 border-b border-primary pb-[1.6rem] pr-[4rem] pt-[0.8rem]">
              <DrawerTitle className="text-[2.2rem] font-semibold leading-[3rem] text-main">Send money</DrawerTitle>
              <DrawerDescription className="mt-[0.4rem] text-[1.3rem] leading-[2rem] text-second">Choose how you want to send funds from this wallet.</DrawerDescription>
              <Button type="button" variant="ghost" size="icon" aria-label="Close send money" onClick={() => onOpenChange(false)} className="absolute right-0 top-[0.4rem] text-main">
                <X className="h-[2rem] w-[2rem]" />
              </Button>
            </header>
            <div className="min-h-0 overflow-x-hidden overflow-y-auto pt-[1.6rem]">
              <SendMoneyMethodOptions onExternalTransfer={selectExternalTransfer} />
            </div>
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-3.2rem)] max-w-[76rem] rounded-[1.6rem] border border-primary bg-secondary p-[2.4rem] text-main shadow-[0_2.4rem_6rem_rgba(0,0,0,0.28)]" overlayClassName="bg-black/55 backdrop-blur-[2px]" onOpenAutoFocus={(event) => event.preventDefault()}>
        <header className="relative border-b border-primary pb-[1.8rem] pr-[4.4rem]">
          <DialogTitle className="text-[2.4rem] font-semibold leading-[3.2rem] text-main">Send money</DialogTitle>
          <DialogDescription className="mt-[0.5rem] text-[1.4rem] leading-[2.2rem] text-second">Choose how you want to send funds from this wallet.</DialogDescription>
          <Button type="button" variant="ghost" size="icon" aria-label="Close send money" onClick={() => onOpenChange(false)} className="absolute right-0 top-0 text-main">
            <X className="h-[2rem] w-[2rem]" />
          </Button>
        </header>
        <SendMoneyMethodOptions onExternalTransfer={selectExternalTransfer} />
      </DialogContent>
    </Dialog>
  );
}
